import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};

/**
 * Gentle fade-and-rise on scroll. Content is never left hidden:
 * with reduced motion, or without IntersectionObserver support, it renders fully visible.
 */
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const reduce = useReducedMotion();
  const canObserve = typeof window !== 'undefined' && 'IntersectionObserver' in window;
  if (reduce || !canObserve) {
    return <div className={className} data-id="element-148" data-mp="2nsbgpgjg03to">{children}</div>;
  }
  return <motion.div data-reveal className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-149" data-mp="2sq39sdvtpvzg">
      {children}
    </motion.div>;
}